<script>
    import openedTracker from "../tracking/openedTracker";
    import performanceFactory from "../performance/performance";
    import Cinema from "./Cinema.svelte";
    import closedTracker from "../tracking/closedTracker";

    const DEFAULT_TRACKING_FIELD = "99";
    const performance = performanceFactory(window, "cinema");

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        sourceVariationId,
        recommendationsCount,
        headline,
        recommendations,
        cinemaMeta,
        tracking,
        additionalClickTracking,
        featuresState = {},
    } = $props();

    let hasSheetBeenOpened = $state(false);
    let availableCinemaWidth = $state(0);

    document.addEventListener("oc-sheet-open", (event) => {
        if (event.detail.id === `reco_cinema_sheet_${sourceVariationId}`) {
            availableCinemaWidth = document
                .getElementById(`reco_cinema_sheet_${sourceVariationId}`)
                .shadowRoot.querySelectorAll(".sheet > .sheet__sheet")[0]
                .getBoundingClientRect().width;
            hasSheetBeenOpened = true;
        }
    });

    document.addEventListener("oc-sheet-after-close", (event) => {
        if (event.detail.id === `reco_cinema_sheet_${sourceVariationId}` && hasSheetBeenOpened) {
            closedTracker(tracking, DEFAULT_TRACKING_FIELD, sourceVariationId);
            hasSheetBeenOpened = false;
        }
    });

    const openedCallback = (numberOfVisibleTiles) => {
        const recommendationsTracking = recommendations
            .slice(0, numberOfVisibleTiles + 1)
            .map((recommendation) => recommendation.tracking);
        openedTracker(tracking, recommendationsTracking, DEFAULT_TRACKING_FIELD, sourceVariationId);
    };
</script>

<div class="reco_cinema_sheet_button_row">
    <oc-sheet-v1 id="reco_cinema_sheet_{sourceVariationId}" {headline} no-content-padding>
        {#if hasSheetBeenOpened}
            <Cinema
                {sourceVariationId}
                {recommendations}
                {cinemaMeta}
                {tracking}
                {additionalClickTracking}
                cinemaIndex={DEFAULT_TRACKING_FIELD}
                featureIndex={DEFAULT_TRACKING_FIELD}
                site="reco_wishlist_sheet"
                {performance}
                {openedCallback}
                {featuresState}
                wishlist_class={true}
                cinemaInjectionContainerWidth={availableCinemaWidth}
                removeFilterCallBack={() => {}}
            />
        {/if}
    </oc-sheet-v1>
    <div
        class="oc-py-75 oc-px-100"
        data-oc-sheet-v1-open
        data-oc-sheet-v1-open.id="reco_cinema_sheet_{sourceVariationId}"
    >
        <oc-link-v2 icon-right="arrow-right" class="reco_cinema_sheet_button" as-button>
            Alternativen anzeigen ({recommendationsCount})
        </oc-link-v2>
    </div>
</div>

<style lang="scss">
    .reco_cinema_sheet_button_row {
        background-color: var(--oc-base-color-white-100);
    }
</style>
